// extracted by mini-css-extract-plugin
module.exports = {"categoryIcon":"category-name-module--category-icon--3jCa3","categoryIcon__icon":"category-name-module--category-icon__icon--1ETXE"};